export default __webpack_public_path__ + "static/media/logo.6eb5d7e0.svg";